import { SVGProps } from 'react';

const MailIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <path
      d="M3.5 9.33333L12.705 15.47C13.0884 15.7258 13.5391 15.8623 14 15.8623C14.4609 15.8623 14.9116 15.7258 15.295 15.47L24.5 9.33333M5.83333 22.1667H22.1667C22.7855 22.1667 23.379 21.9208 23.8166 21.4832C24.2542 21.0457 24.5 20.4522 24.5 19.8333V8.16666C24.5 7.54782 24.2542 6.95433 23.8166 6.51675C23.379 6.07916 22.7855 5.83333 22.1667 5.83333H5.83333C5.21449 5.83333 4.621 6.07916 4.18342 6.51675C3.74583 6.95433 3.5 7.54782 3.5 8.16666V19.8333C3.5 20.4522 3.74583 21.0457 4.18342 21.4832C4.621 21.9208 5.21449 22.1667 5.83333 22.1667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MailIcon;
